export default __webpack_public_path__ + "static/media/BIG_TIC_IT_Cp_background.0fcd99c3.png";